import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import usePermissionCheckerQuery from '../hooks/usePermissionCheckerQuery';
import { PermissionCollection } from '../types';

interface PermissionCheckerProps {
  requiredPermissions?: PermissionCollection['codename'][];
  operation?: 'and' | 'or';
  redirectTo?: string;
  isLoading?: boolean;
  condition?: boolean;
}

const PermissionChecker: React.FC<PermissionCheckerProps> = ({
  requiredPermissions = [],
  children,
  redirectTo,
  operation,
  isLoading,
  condition,
}) => {
  const permissionChecker = usePermissionCheckerQuery(requiredPermissions, operation);

  const loading = permissionChecker.isLoading || isLoading;

  if (loading) {
    return null;
  }

  if (permissionChecker.data || condition) {
    return children ? (children as ReactElement) : <Outlet />;
  }

  if (permissionChecker.isSuccess && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return null;
};

export default PermissionChecker;
